<template>
  <div class="lives-wrapbox">
    <live-list :checked-list="info.webinars" />
  </div>
</template>
<script>
  /**
   * 直播自定义菜单
   */
  import liveList from './live-list';

  export default {
    name: 'component-video',
    props: {
      info: {
        required: false
      }
    },
    components: {
      liveList
    }
  };
</script>
<style lang="less" scoped>
  .lives-wrapbox {
    width: 100%;
    margin-bottom: 16px;
  }
</style>
